<template lang="pug">
  div(:class="inline|columnGird(column.form.columnSize)")
    .form-group(:class="[{'row':!inline},{'has-error':errorState.$error}]" :hidden="column.form.hidden")
      label.col-form-label.text-sm-right(
        v-if="columnsLabelShow"
        :for="'form-'+columnName"
        :class="!inline?(column.form.labelSize||labelSize):null|labelGird(column.form.size)")
        span.text-danger(v-if="labelRequired") *
        | {{column.label}}
      div(:class="!inline?(column.form.labelSize||labelSize):null|antiLabelGird|labelGird")
        .input-group(
          :class="'input-group-'+column.form.size"
          :style="groupStyle")
          SmartFormAddon(v-if="column.form.prefix",v-bind="column.form.prefix")
          SmartText(
            v-if="column.form.type === 'text'"
            :column="column"
            :columnName="columnName"
            v-model="currentValue")
          SmartInput.form-control(
            v-else-if="column.form.type === 'input'"
            :dataType="column.dataType"
            v-bind="column.form"
            v-on:SmartInput='Fdemo'
            v-model="currentValue")
          SmartPassword.form-control(
            v-else-if="column.form.type === 'password'"
            v-bind="column.form"
            v-model="currentValue")
          SmartSelect(
            v-else-if="column.form.type === 'select'"
            v-bind="column.form"
            v-model="currentValue"
            :options="options")
          SmartTree(
            v-else-if="column.form.type === 'tree'"
            v-bind="column.form"
            v-model="currentValue"
            :options="options")
          SmartCascader(
            v-else-if="column.form.type === 'cascader'"
            v-bind="column.form"
            :currentValue="currentValue"
            v-model="currentValue"
            :options="options")
          SmartDate(
            v-else-if="column.form.type === 'date'"
            v-bind="column.form"
            v-model="currentValue"
            :disabled="column.form.disabled"
            :options="options")
          SmartDate(
            v-else-if="column.form.type === 'month'"
            v-bind="column.form"
            v-model="currentValue"
            :dateType="column.dateType"
            :disabled="column.form.disabled"
            :options="options")
          SmartDateRange(
            v-else-if="column.form.type === 'daterange'"
            v-bind="column.form"
            v-model="currentValue"
            :dataType="column.dataType"
            :disabled="column.form.disabled"
            :options="options")
          SmartTimePicker(
            v-else-if="column.form.type === 'time'"
            v-bind="column.form"
            v-model="currentValue"
            :currentValue="currentValue"
            :options="options"
          )
          SmartSwitch(
            v-else-if="column.form.type === 'switch'"
            v-bind="column.form"
            v-model="currentValue"
            :currentValue="currentValue"
            :options="options")
          //- SmartNumber.form-control(
          //-   v-else-if="column.form.type === 'number'"
          //-   v-bind="column.form"
          //-   v-model="currentValue"
          //-   :currentValue="currentValue"
          //-   :options="options")
          SmartNumber(
            v-else-if="column.form.type === 'number'"
            :dataType="column.dataType"
            v-bind="column.form"
            v-model="currentValue")
          SmartButton(
            v-else-if="column.form.type === 'button'"
            :dataType="column.dataType"
            v-bind="column.form"
            v-on:SmartInput='Fdemo')
          SmartFormAddon(v-if="column.form.suffix",v-bind="column.form.suffix")
        <el-button v-if="column.form.search" type="button" id="search-button" class="iconfont icon-map" @click='Fdemo()'></el-button>
        .help
          a(v-if="column.form.helpHref" :href="column.form.helpHref" download="") {{column.form.help}}
          span(v-else) {{column.form.help}}
        .error {{errorMassage}}
</template>

<script>
import SmartText from './SmartText'
import SmartInput from './SmartInput'
import SmartPassword from './SmartPassword'
import SmartSelect from './SmartSelect'
import SmartTree from './SmartTree'
import SmartCascader from './SmartCascader'
import SmartDate from './SmartDate'
import SmartDateRange from './SmartDateRange'
import SmartTimePicker from './SmartTimePicker'
import SmartSwitch from './SmartSwitch'
// import SmartTextarea from './SmartTextarea'
import SmartNumber from './SmartNumber'
// import SmartCheckbox from './SmartCheckbox'
// import SmartMultiselect from './SmartMultiselect'
import SmartFormAddon from './SmartFormAddon'
import SmartButton from './SmartButton'
import '@/assets/css/iconfont.css'

export default {
  name: 'SmartFormItem',
  props: {
    columnName: String, // 字段名
    column: Object, // 字段配置信息
    inline: Boolean, // 表单布局形式，是否行内布局
    columnsLabelShow: {
      type: Boolean,
      default: true
    },
    labelSize: {
      type: Number,
      default: 3
    }, // 字段标签长度
    value: String | Number | Object | Array | Set, // 表单控件的值
    options: Array, // 字段对应的选项集
    errorState: {
      type: Object,
      default: () => ({})
    }, // 表单控件的值是否出错，出错的状态
    isWidthAll: {
      type: Boolean,
      default: false
    } // 表单控件是否宽度100%，不受column.Width控制，例如：高级搜索中的表单
  },
  components: {
    SmartInput,
    SmartText,
    SmartSelect,
    SmartPassword,
    SmartTree,
    SmartFormAddon,
    SmartCascader,
    SmartDate,
    SmartDateRange,
    SmartTimePicker,
    SmartSwitch,
    SmartNumber,
    SmartButton
  },
  data () {
    const { rules } = this.column.form
    // let req = !this.column.form.hidden && rules ? rules.filter(rule => rule.type === 'required').length : false // 小区用水暂时不要
    // let search = ''
    return {
      groupStyle: {width: this.isWidthAll ? '100%' : this.column.form.width + 'px'}, // 表单控件的长度
      search: rules ? rules.filter(rule => rule.search) : [],
      errorMassage: '', // 表单错误提示文字，会根据错误状态改变
      labelRequired: rules ? rules.filter(rule => rule.type === 'required').length : false // 此字段是否必填
    }
  },
  watch: {
    column: {
      deep: true,
      handler (val) {
        let isNeedUpdateOldValue = this.column.form.isNeedUpdateOldValue
        if (isNeedUpdateOldValue !== undefined && isNeedUpdateOldValue) this.currentValue = this.column.form.oldValue
      }
    },
    errorState: {
      deep: true,
      handler (errorState) {
        if (!errorState.$error) {
          this.errorMassage = ''
        } else {
          this.column.form.rules.map(rule => {
            if (!this.column.form.hidden && !errorState[rule.type]) {
              this.errorMassage = rule.message
            }
          })
        }
      }
    } // 监听字段填写出错的状态，改变表单的错误提示文字
  },
  filters: {
    labelGird (labelSize, size) {
      const labelClass = labelSize ? 'col-sm-' + labelSize : null
      const sizeClass = size ? 'col-form-label-' + size : null
      return [labelClass, sizeClass]
    }, // 计算label长度
    antiLabelGird (labelSize) {
      return labelSize ? 12 - labelSize : null
    }, // 计算表单组件长度
    columnGird (inline, columnSize = [{type: 'md', size: '12'}]) {
      return !inline ? columnSize.map(size => {
        return `col-${size.type}-${size.size}`
      }) : []
    } // 计算表单项长度
  },
  computed: {
    currentValue: {
      get () {
        return this.value
      }, // 表单数据绑定
      set (val) {
        this.$emit('input', val)
        this.$emit('changeFormValue', {name: this.columnName, value: val})
      } // 表单数据绑定，并广播字段操作信息
    }
  },
  methods: {
    Fdemo () {
      this.$emit('SmartInput')
    }
  }
}
</script>
<style lang="sass" scoped>
#search-button
  position: absolute
  top: 0
  right: 8px;
.input-group
  .form-control
    z-index: auto
.form-group
  .col-form-label
    .text-danger
      font-size: 20px
      line-height: 20px
      padding-right: 4px
      vertical-align: text-top
.help, .help>a
  color: #007bff
</style>



// WEBPACK FOOTER //
// index.vue?fbe4c066